import { IntroStep } from '../../../core/services/tour.service';

export const schoolDashboardIntroSteps: IntroStep[] = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#printButton',
    intro: 'Click here to print the School Dashboard report.'
  },
  {
    element: '.dashboard-header-bar',
    intro: 'School Dashboard is where you can find an overview of data for the school. You can see the number of teachers and '
      + 'students enrolled, and view school, teacher, and student engagement data.',
  },
  {
    element: '.summary-cards-row',
    intro: 'See the number of teachers and students enrolled in the WordFlight System in your school.',
  },
  {
    element: '#date-range-row',
    intro: 'Select a date range from the dropdown to view data for that week.',
    position: 'bottom-right-aligned',
  },
  {
    element: '#classroom-engagement',
    intro: 'See the number of classrooms with at least 60 minutes of average weekly usage per week for the selected week(s). See '
      + 'the top three classrooms by student engagement. WordFlight recommends students complete 60-80 minutes of practice in the '
      + 'Online Student Program each week. This is where we see best results.',
  },
  {
    element: '#teacher-usage',
    intro: 'See the percentage of teachers with at least one WordFlight Management Site login per week and the top three schools '
      + 'by teacher engagement for the selected week(s). WordFlight recommends teachers log in to the Management Site 2-3 times '
      + 'per week to review and monitor student data.',
  },
  {
    element: '.student-engagement-body',
    intro: 'See the percentage of students in each weekly minutes range for the selected week(s). WordFlight recommends '
      + 'students complete 60-80 minutes of practice in the Online Student Program each week. This is where we see best results.',
  },
  {
    element: '.student-units-row',
    intro: 'See the number of students completing at least one unit per week for the selected week(s).',
  }
];
